const flatOrg = (current, org) => {
  current.push(org);

  if (org.children) {
    return org.children.reduce(flatOrg, current);
  }

  return current;
};

export const flattenOrgs = (orgs) => {
  return orgs.reduce(flatOrg, []);
};

export const flattenOrg = (org) => {
  return flatOrg([], org);
};

export const orgsToOptions = (orgs) => {
  return orgs.filter((org) => org.id !== '').map((org) => ({
    label: `${'> '.repeat(Math.max(0, (org.path || 0).length - 1))}${org.name}`,
    value: org.id || '',
    org
  }));
};
